// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__dQbO0","content":"Banner_content__pdsas","title":"Banner_title__seJED","text":"Banner_text__ZS0DL","image":"Banner_image__0hCGj"};